import http from './http'

class LiquidationRequest {
  save (payload) {
    return http.post('/liquidation_requests', { liquidation_request: payload })
  }

  fetchInvoices (payload) {
    return http.post('/liquidation_requests/total_invoices', { liquidation_request: payload })
  }

  exportCnabFile (id) {
    return http.get(`/admin_back_office/export_cnab_file_liquidation/${id}/download`)
  }
}

export default new LiquidationRequest()



// WEBPACK FOOTER //
// ./src/services/liquidation_request.js